import { IconButton } from '@mui/material';
import { useChatbot } from '@/feature/chatbot/useChatbot';
import { useTexts } from '@/feature/lang';
import { Icon } from '@/icon/Icon';
import { IconSize } from '@/icon/types';
import Tooltip from '../../Tooltip/Tooltip';

export const CreateNewButton = ({
  iconSize = 'medium',
}: {
  iconSize?: IconSize;
}) => {
  const texts = useTexts().component.chatbot;
  const { createNew, isChatEmpty } = useChatbot();

  return isChatEmpty ? (
    <IconButton size="small" disabled>
      <Icon name="add" size={iconSize} />
    </IconButton>
  ) : (
    <Tooltip title={texts.actions.newConversation}>
      <IconButton size="small" onClick={createNew}>
        <Icon name="add" size={iconSize} />
      </IconButton>
    </Tooltip>
  );
};
